export default __webpack_public_path__ + "static/media/group.9b0c33ce.png";